import { connect } from 'react-redux';
import { get } from 'lodash';
import type { PortfolioProps } from '@/components/DeprecatedPortfolio';
import Portfolio from '@/components/DeprecatedPortfolio';
import {
  redirectToEditTransactions,
  deletePortfolio,
} from '@/components/DeprecatedPortfolio/redux/actions';
import {
  portfolioSelector,
  portfolioSummarySelector,
  getPortfolioMutableState,
} from '@/components/DeprecatedPortfolio/redux/selectors';
import { fetchPortfolioCsvReport, fetchPortfolio } from '../redux/routines';
import { redirect } from 'redux-first-router';
import { ROUTE_PLANS } from '@/constants/routes';
import { ShowEditPortfolioModal } from '../components/EditPortfolioModal/redux';

type StateProps = Pick<
  PortfolioProps,
  | 'isEditable'
  | 'id'
  | 'name'
  | 'provider'
  | 'currentHoldingCount'
  | 'totalValueFormatted'
  | 'currencyISO'
  | 'isWatchlist'
  | 'score'
  | 'loadingCsvReport'
  | 'secretCode'
>;
const mapStateToProps = (state): StateProps => {
  const portfolio = portfolioSelector(state);
  const summary = portfolioSummarySelector(state);
  const isEditable = getPortfolioMutableState(state);

  return {
    isEditable,
    id: get(portfolio, 'id', null),
    name: get(portfolio, 'name', ''),
    provider: get(portfolio, 'provider', null),
    currentHoldingCount: get(portfolio, 'currentHoldingCount', 0),
    totalValueFormatted: summary ? summary.totalValueFormatted : 'NA',
    currencyISO: portfolio?.currencyISO,
    isWatchlist: portfolio ? portfolio.isWatchlist : true,
    score: (summary && summary.snowflakeScoreAxes) || [],
    loadingCsvReport: state.ui.fileIsDownloading,
    secretCode: get(portfolio, 'secretCode', null),
  };
};

type DispatchProps = Pick<
  PortfolioProps,
  | 'redirectToEditTransactions'
  | 'handleFetchCompanyCsvReport'
  | 'handleShowPlans'
  | 'handlePortfolioRefresh'
  | 'handleShowEditPortfolio'
  | 'handleDeletePortfolio'
>;
const mapDispatchToProps = (dispatch): DispatchProps => {
  return {
    redirectToEditTransactions: (data) =>
      dispatch(redirectToEditTransactions(data)),
    handleFetchCompanyCsvReport: (portfolioId) => {
      dispatch(fetchPortfolioCsvReport.trigger({ portfolioId }));
    },
    handleShowPlans: () => dispatch(redirect({ type: ROUTE_PLANS })),
    handlePortfolioRefresh: (data) =>
      dispatch(fetchPortfolio.trigger({ id: data, refresh: 1 })),
    handleShowEditPortfolio: () => dispatch(ShowEditPortfolioModal.trigger()),
    handleDeletePortfolio: (data) => dispatch(deletePortfolio(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Portfolio);
